import moment from 'moment';

export async function fetchOusdApy() {
  try {
    const response = await fetch('https://analytics.ousd.com/api/v1/apr/trailing/30');
    if (!response.ok) {
      console.warn('fetchOusdApy', response.status);
    }
    const apy = await response?.json();
    // console.log('OUSD Apy updated: [' + moment().format('LTS') + ']');
    return apy.apy;
  } catch (err) {
    console.log('fetchOusdApy err: ', err);
    throw err;
  }
}

export async function fetchArchPrice() {
  return Promise.resolve(2.13);
  try {
    const response = await fetch('https://api.coingecko.com/api/v3/simple/price?ids=frax-share&vs_currencies=usd');
    if (!response.ok) {
      console.warn('fetchArchPrice', response.status);
    }
    const price = await response.json();
    console.log('ArchPrice updated: [' + moment().format('LTS') + ']');
    return price['frax-share'].usd;
  } catch (err) {
    console.log(err);
  }
}
